export const OVERLAP = 100;
export const MOBILE_OVERLAP = 120;
